import {formatData} from '@/utils/util'
import moment from 'moment'

export const STATUS={
  FAILED:'FAILED', // 失败 
  SUCCEED:'SUCCEED'// 成功
}
const STATUS_MAP={
  [STATUS.FAILED]:'失败',
  [STATUS.SUCCEED]:'成功'
}


export const PLAN_TYPE={
  CREATED:'创建为新的排线',
  COVER:'覆盖原排线'
}

export const SearchFiled=[
  {
    label:'排线结果',
    name:'result',
    type:'select',
    prop:{
      placeholder: '选择排线结果',
      options: formatData(STATUS_MAP),
      allowClear:true
    },
  },
  {
    label:'失败原因',
    name:'remark',
    type:'select',
    prop:{
      placeholder: '选择失败原因',
      options: [],
      allowClear:true
    },
  },
]

export const PlannedColumns=[
  {
    // title: "Est. Departure Date",
    dataIndex: "planTime",
    slots: { title: 'planTimeTitle' },
    customRender: (text) => text ? moment(text).format('YYYY-MM-DD') : '--',
    width:200
  },
  {
    dataIndex: "dcAndSku",
    slots: { title: 'dcAndSkuTitle' },
    customRender: (text) => text||'--',
    width:160
  },
  {
    slots: { title: 'supplierCodeTitle' },
    dataIndex: "supplierCode",
    customRender: (text) => text||'--',
    width:160

  },
  {
    dataIndex: "warehouseCode",
    slots: { title: 'warehouseCodeTitle' },
    customRender: (text) => text||'--',
    width:160
  },
  {
    dataIndex: "skuCode",
    slots: { title: 'skuCodeTitle' },
    customRender: (text) => text||'--',
    width:160
  },
  {
    dataIndex: "skuName",
    slots: { title: 'skuNameTitle' },
    customRender: (text) => text||'--',
    width:160
  },
  {
    dataIndex: "packing",
    slots: { title: 'packingTitle' },
    customRender: (text) => text||'--',
    width:160
  },
  {
    dataIndex: "skuPallet",
    slots: { title: 'skuPalletTitle' },
    customRender: (text) => text||'--',
    width:160
  },
  {
    dataIndex: "skuAmount",
    slots: { title: 'skuAmountTitle' },
    customRender: (text) => text||'--',
    width:160
  },
  {
    dataIndex: "qty",
    slots: { title: 'qtyTitle' },
    customRender: (text) => text||'--',
    width:160
  },
  {
    dataIndex: "entrepot",
    slots: { title: 'entrepotTitle' },
    customRender: (text) => text||'--',
    width:160
  },
  {
    title:'排线结果',
    dataIndex: "remarks",
    scopedSlots: { customRender: "remarks" },
    width:200
  },
  {
    title:'排线失败原因',
    dataIndex: "remark",
    customRender: (text) => text||'--',
    ellipsis:true
  },
  {
    title:'操作',
    dataIndex: "active",
    scopedSlots: { customRender: "action" },
    width:160,
    fixed:'right'
  }
]

export const customr=[
  {customrTitle:'planTimeTitle',label:'Est. Departure Date',prop:'planTime',type:'date',required:true},
  {customrTitle:'dcAndSkuTitle',label:'DC&SKU',prop:'dcAndSku',type:'input',required:false},
  {customrTitle:'supplierCodeTitle',label:'Supplier',prop:'supplierCode',type:'input',required:true},
  {customrTitle:'warehouseCodeTitle',label:'Depot',prop:'warehouseCode',type:'input',required:true},
  {customrTitle:'skuCodeTitle',label:'SKU',prop:'skuCode',type:'input',required:false},
  {customrTitle:'skuNameTitle',label:'Description',prop:'skuName',type:'input',required:false},
  {customrTitle:'packingTitle',label:'Packing',prop:'packing',type:'input',required:false},
  {customrTitle:'skuPalletTitle',label:'Pallet',prop:'skuPallet',type:'input',required:true},
  {customrTitle:'skuAmountTitle',label:'Case',prop:'skuAmount',type:'input',required:true},
  {customrTitle:'qtyTitle',label:'Qty',prop:'qty',type:'input',required:false},
  {customrTitle:'entrepotTitle',label:'集散中心',prop:'entrepot',type:'input',required:false},
]